@for (n of numbersIterate(); track n) {
  <div class="col-12 col-md-6 mb-4">
    <div class="fb-item">
      <div class="first-section-wrapper">
        <div class="gravatar w-100 p-2">
          <ngx-skeleton-loader [theme]="{ width: '100%', height: '220px', borderRadius: '12px' }" />
        </div>
      </div>
      <div class="second-section-wrapper">
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '80%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px',
            }"
          />
        </div>
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '90%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px',
            }"
          />
        </div>
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '60%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px',
            }"
          />
        </div>
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '60%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px',
            }"
          />
        </div>
        <div class="wrapper">
          <ngx-skeleton-loader
            [theme]="{
              width: '60%',
              'border-radius': '0',
              height: '15px',
              'margin-bottom': '10px',
            }"
          />
        </div>
      </div>
    </div>
  </div>
}
